import { site } from '@panel/commons/helpers';

export const countriesIds = {
  '24MX': { countryCode: '18', gmapCode: 'mx' },
  DVPE: { countryCode: '11', gmapCode: 'pe' },
  UBPE: { countryCode: '111', gmapCode: 'pe' },
  PLEC: { countryCode: '9', gmapCode: 'ec' },
  CAPA: { countryCode: '20', gmapCode: 'pa' },
  LLVE: { countryCode: '13', gmapCode: 've' },
  ZPAR: { countryCode: '1', gmapCode: 'ar' },
  ICBR: { countryCode: '2', gmapCode: 'br' },
  IWBR: { countryCode: '2', gmapCode: 'br' },
  WIBR: { countryCode: '2', gmapCode: 'br' },
  VAMX: { countryCode: '36', gmapCode: 'mx' }
};

export const formatCep = value => {
  if (!value) return null;
  const matchFormat = value.replace(/\s/g, '').match(/\d{3,5}/g);
  const result = matchFormat ? matchFormat.join('-').substr(0, 9) : null;
  return /[0-9]{5}-?[\d]{3}/.test(result) ? result : value;
};

const hasNoSubDistrict = ['24MX', 'PLEC', 'CAPA', 'LLVE', 'VAMX'];

export const hasCep = ['IWBR', 'WIBR', 'ICBR'].includes(site.id);

export const addressSeparator = ['IWBR', 'WIBR', 'ICBR'].includes(site.id) ? '-' : ',';

export const showSubDistrict = hasNoSubDistrict.indexOf(site.id) !== -1;
